import { renderToggleButton_unstable } from '@fluentui/react-button';

/**
 * Renders the final JSX of the ToolbarToggleButton component, given the state.
 */
export const renderToolbarToggleButton = renderToggleButton_unstable;
